import {
  CustomerBankAccountMandateStateEnumType,
  Maybe,
  B2BPaymentMethod,
  PaymentMethodState,
} from "@oysterhr/schema"
import { Alert, Link, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { PaymentMethodEnumType } from "~/app/utils/constants"
import { MandateSign } from "../sepa/hooks/useMandateSign"

interface SignMandateAlertProps {
  paymentMethod?: Maybe<B2BPaymentMethod>
  mandateSign: MandateSign
}

export const SignMandateAlert = ({ paymentMethod, mandateSign }: SignMandateAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")
  const { accountAspect: companyId } = useAccountAspect()
  const { onMandateSign, isSigning } = mandateSign
  // Hide alert if payment method has not been authorized by user or if mandate is not in first state
  if (
    !paymentMethod ||
    isSigning ||
    paymentMethod.__typename !== PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    paymentMethod.userNotSigner ||
    paymentMethod.state !== PaymentMethodState.AuthorizedByUser ||
    paymentMethod.mandate?.state !== CustomerBankAccountMandateStateEnumType.Initialized
  )
    return null

  const onSignMandate = () => {
    const mandateSignURL = paymentMethod.mandate?.signerRecipientViewUrl

    if (mandateSignURL) {
      // If mandate url already exists we don't show the toast about generation
      onMandateSign(companyId, false)
    } else {
      onMandateSign(companyId)
    }
  }

  return (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content className="flex space-x-1">
        <div className="flex flex-col">
          <div className="inline-flex space-x-1">
            <Text>{t("alerts.mandate.content")} </Text>
            <Link as="button" onClick={onSignMandate}>
              {t("alerts.mandate.action")}
            </Link>
          </div>
          <Text>{t("alerts.mandate.disclaimer")}</Text>
        </div>
      </Alert.Content>
    </Alert>
  )
}
